// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__cWady","content":"GlobalSearch_content__1E-EV"};